export type LastSystem = "platform" | "spend";

const LAST_SYSTEM_KEY = "lastSystem";

export function setLastSystem(system: LastSystem) {
  try {
    localStorage.setItem(LAST_SYSTEM_KEY, system);
  } catch {
    // localStorage unavailable (private mode, etc.) — fail silently
  }
}

export function getLastSystem(): LastSystem | null {
  try {
    const value = localStorage.getItem(LAST_SYSTEM_KEY);
    return value === "platform" || value === "spend" ? value : null;
  } catch {
    return null;
  }
}
